<template>
  
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    //初始化
    created(){

    },
    methods:{

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/test.vue